export default __webpack_public_path__ + "static/media/dMT4.fbd7dcc7.png";